<template lang="pug">
    select(
        class="text-xs w-full pl-3 pr-3 caret-slate-300 border border-slate-300 bg-white"
        @change="onSelect"
        v-model="selected"
    )
        template(v-for="(item, index) in options")
            option(:key="index" :selected="item.selected") {{ item.name }}
</template>

<script>
export default {
    name: "Select",
    props: {
        options: {
            type: Array,
            default: () => [],
        },
        predefined: {
            type: String,
        },
    },
    data() {
        return {
            selected: '',
        }
    },
    methods: {
        onSelect() {
            this.$emit('value', this.selected)
        },
    },
    watch: {
        predefined: {
            handler(val) {
                if (val)
                    this.selected = val
            },
            deep: true,
            immediate: true,
        },
    }
}
</script>